// May this account make the 3D animated corrido (FaceShot Animation)?
// GET /api/web/corrido3d/access (services/corrido-3d/mount.js) answers
// { enabled, access: "admin" | "all", allowed }. Asked once per signed-in
// account and shared by everything on the page that needs it: the look choice
// in the corrido flow's first step and the look bar above it. Signed out reads
// as "not allowed". A failed ask (an error answer, no network) is UNKNOWN
// (null): the choice stays hidden, but a page already on 3D stays on 3D - a
// blip used to flip a running 3D board's page to realism (owner, 2026-10-11).

export type Corrido3dAccess = { allowed: boolean; access: "admin" | "all"; enabled: boolean };

const NOT_ALLOWED: Corrido3dAccess = { allowed: false, access: "admin", enabled: false };

let cached: { token: string; promise: Promise<Corrido3dAccess | null> } | null = null;

function token(): string | null {
  try { return localStorage.getItem("auth_token"); } catch { return null; }
}

function read(j: unknown): Corrido3dAccess {
  if (!j || typeof j !== "object") return NOT_ALLOWED;
  const r = j as Record<string, unknown>;
  if (typeof r.allowed !== "boolean") return NOT_ALLOWED;
  return { allowed: r.allowed, access: r.access === "all" ? "all" : "admin", enabled: Boolean(r.enabled) };
}

/** The account's answer (one request per sign-in); null when signed out;
 *  resolves null when the ask failed (unknown). */
export function fetchCorrido3dAccess(): Promise<Corrido3dAccess | null> | null {
  const tok = token();
  if (!tok) return null;
  if (cached && cached.token === tok) return cached.promise;
  const promise = fetch("/api/web/corrido3d/access", { headers: { Authorization: `Bearer ${tok}` } })
    .then((r) => {
      if (!r.ok) throw new Error(`access ${r.status}`);
      return r.json();
    })
    .then(read)
    .catch((): Corrido3dAccess | null => {
      // A failed ask is not remembered: the next mount asks again.
      if (cached && cached.token === tok) cached = null;
      return null;
    });
  cached = { token: tok, promise };
  return promise;
}

/** Test seam only. */
export function _resetCorrido3dAccess(): void {
  cached = null;
}
